<template>
  <!--    temporary  clipped fixed -->
  <!--    touchless-->
  <div v-if="$route.name !== 'Standorte'">
    <v-navigation-drawer v-model="thisDrawer" temporary fixed light class="vvd">
      <!--        class="transparent"-->
      <!--        <v-toolbar flat class="myAppHead">-->

      <!--<v-list-item-icon>-->
      <!--<v-icon @click.native.passive="close">chevron_left</v-icon>-->
      <!--</v-list-item-icon>-->

      <v-divider></v-divider>

      <v-list-item @click="close" class="pointer sideItem" dark>
        <!--            <v-list-item @click="close" class="pointer sideItem" style="height: 100px; overflow: hidden;" dark>-->
        <v-list-item-content>
          <div class="d-flex align-center" @click.passive="close">
            <div>
              <v-icon medium>mdi-arrow-left</v-icon>
            </div>
            <div class="text-center flex-grow-1">
              <img style="width: 80px; height: auto; flex: none;"
                   src="../assets/placeholder6-opti.png" @click.passive="gotoStart">
            </div>
            <!--                    <div class="maxh text-right">-->
            <!--                        <v-icon medium @click.native.passive="close">mdi-close-thick</v-icon>-->
            <!--                    </div>-->
          </div>


          <!--                <v-list-item-title class="myDisplay1">-->
          <!--                    <span style="letter-spacing: 0">THEURER</span>-->
          <!--                </v-list-item-title>-->
          <!--                <v-list-item-subtitle>-->
          <!--                    <span class="pl-2">Schmeckt mir lieber.</span>-->
          <!--                </v-list-item-subtitle>-->
        </v-list-item-content>
      </v-list-item>

      <!--        <div class="myToolbar">-->
      <!--            <v-list :dark="true">-->
      <!--                <v-list-item>-->
      <!--                    <v-list-item-content>-->
      <!--                        <div class="title">{{$store.getters.storeName}}</div>-->
      <!--                    </v-list-item-content>-->

      <!--                    <v-list-item-icon @click="close" class="pointer">-->
      <!--                        <v-icon>mdi-close</v-icon>-->
      <!--                    </v-list-item-icon>-->

      <!--                </v-list-item>-->
      <!--            </v-list>-->
      <!--        </div>-->


      <div class="sideContainer">

        <v-list-item @click.native.passive="gotoStart">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Startseite</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <!--            <template v-if="!hasAccount()">-->
        <!--                <v-list-item @click.native.passive="register">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-account-plus</v-icon>-->
        <!--                        &lt;!&ndash;                        add_circle&ndash;&gt;-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Registrieren</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->
        <!--            </template>-->


        <template v-if="$store.state.enableAccount">
          <!--                <template v-if="hasAccount() || $store.getters.loggedIn">-->
          <v-list-item @click.native.passive="goAccountOrSignin">
            <v-list-item-icon>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ accountName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>


        <!--            <v-list>-->
        <!--                <v-divider></v-divider>-->

        <!--                <v-list-item v-if="!$store.getters.inhouse" @click.native.passive="gotoOeffnungszeiten">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-clock-outline</v-icon>-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Startseite</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->

        <!--      <template v-if="!$store.getters.inhouse">-->
        <!--        <v-list-item-->
        <!--          @click.native.passive="gotoAbholzeiten">-->
        <!--          <v-list-item-icon>-->
        <!--            <v-icon>mdi-clock-outline</v-icon>-->
        <!--            &lt;!&ndash;                        add_circle&ndash;&gt;-->
        <!--          </v-list-item-icon>-->
        <!--          <v-list-item-content>-->
        <!--            <v-list-item-title>Abholzeiten</v-list-item-title>-->
        <!--          </v-list-item-content>-->
        <!--        </v-list-item>-->
        <!--        <v-divider></v-divider>-->
        <!--      </template>-->


        <!--                <v-list-item  @click.native.passive="gotoOpeningHours">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-store</v-icon>-->
        <!--                        &lt;!&ndash;                        add_circle&ndash;&gt;-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Filialen & Öffnungszeiten</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->

        <v-list-item @click.native.passive="gotoSortiment">
          <v-list-item-icon>
            <v-icon>mdi-food</v-icon>
            <!--                    <v-icon>mdi-food-fork-drink</v-icon>-->
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Sortiment</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <template v-if="$store.state.enableFavs">
          <v-list-item @click.native.passive="goFavs">
            <v-list-item-icon>
              <v-icon>mdi-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Favoriten</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>

        <template v-if="$store.state.enableNews">
          <v-list-item
            @click.native.passive="gotoAktuelles">
            <v-list-item-icon>
              <v-icon>mdi-bell</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Aktuelles</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>

        <v-list-item @click.native.passive="goLastOrders">
          <v-list-item-icon>
            <v-icon>mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Bestellungen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <template v-if="$store.getters.inhouse && $store.state.enableKellnerruf">
          <v-list-item
            @click.native.passive="goKellnerruf">
            <v-list-item-icon>
              <!--                    <v-icon>mdi-room-service</v-icon>-->
              <img class="dotImg" src="../assets/icons/waiter.png">
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Kellnerruf</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>

        <v-list-item @click.native.passive="goAllergene">
          <!--            <v-list-item @click.native.passive="gotoWebsite('https://lunchbox-eatfresher.de/allergene/')">-->
          <v-list-item-icon>
            <v-icon>mdi-barley</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Allergene</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>


        <!--            <v-list-item v-if="!$store.getters.inhouse" @click.native.passive="gotoAnfahrt">-->
        <!--                <v-list-item-icon>-->
        <!--                    <v-icon>mdi-google-maps</v-icon>-->
        <!--                </v-list-item-icon>-->
        <!--                <v-list-item-content>-->
        <!--                    <v-list-item-title>Anfahrt</v-list-item-title>-->
        <!--                </v-list-item-content>-->
        <!--            </v-list-item>-->
        <!--            <v-divider></v-divider>-->


        <template v-if="$store.getters.inhouse && takeawayEnabled">
          <v-list-item @click.native.passive="enableTakeawayMode">
            <v-list-item-icon>
              <v-icon>mdi-toggle-switch-off-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Takeaway Modus</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>

        <template v-if="!$store.getters.inhouse && showInhouseMode">
          <v-list-item @click.native.passive="enableInhouseMode">
            <v-list-item-icon>
              <v-icon>mdi-toggle-switch-off-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Inhouse Modus</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>

        <template>
          <!--          <template v-if="$store.state.showInstallPwa || isApple">-->
          <v-list-item @click.native.passive="install">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
              <!--                        add_circle-->
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>App installieren</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>

        <template>
          <v-list-item @click.native.passive="$ebus.$emit('shareApp')">
            <v-list-item-icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>App teilen</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>


        <!--            <template v-if="hasAccount() && !$store.getters.loggedIn">-->
        <!--                <v-list-item @click.native.passive="signin">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-key</v-icon>-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Anmelden</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->
        <!--            </template>-->


        <!--                <v-list-item @click.native.passive="goOffers">-->
        <!--                    <v-list-item-icon>-->
        <!--                        &lt;!&ndash;                        <v-icon>local_offer</v-icon>&ndash;&gt;-->
        <!--                        <img src="../assets/icons/discount-red.png">-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Angebote</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->

        <!--                <v-list-item @click.native.passive="goProducts">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-cart-outline</v-icon>-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Online-Shop</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->

        <!--                            <v-list-item @click.native.passive="goGutscheine" class="punkt-coupons">-->
        <!--                                <v-list-item-icon>-->
        <!--                                    &lt;!&ndash;                        <v-icon>loyalty</v-icon>&ndash;&gt;-->
        <!--                                    <v-icon>mdi-ticket-percent</v-icon>-->
        <!--            &lt;!&ndash;                        <img src="../assets/icons/gutschein.png">&ndash;&gt;-->
        <!--                                </v-list-item-icon>-->
        <!--                                <v-list-item-content>-->
        <!--                                    <v-list-item-title>Gutscheine</v-list-item-title>-->
        <!--                                </v-list-item-content>-->
        <!--                            </v-list-item>-->
        <!--                            <v-divider></v-divider>-->


        <!--                //TODO activate for online-->
        <!--                <v-divider v-if="$store.getters.loggedIn"></v-divider>-->
        <!--                <v-list-item v-if="$store.getters.loggedIn" @click.native.passive="goLastOrders">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-history</v-icon>-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Letzte Bestellungen</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider v-if="$store.getters.loggedIn"></v-divider>-->


        <!--                //TODO activate for online-->
        <template v-if="enableGoodpay && ($store.getters.loggedIn || $store.getters.paymentMethods.length>0)">
          <v-list-item @click.native.passive="goPaymentMethods">
            <v-list-item-icon>
              <v-icon>mdi-credit-card</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Zahlungsmittel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>


        <!--                <v-list-item @click.native.passive="triggerKontakt">-->
        <!--                    <v-list-item-icon>-->
        <!--                        <v-icon>mdi-comment-processing</v-icon>-->
        <!--                    </v-list-item-icon>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Kontakt aufnehmen</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-divider></v-divider>-->


        <v-list-group
          :value="false"
          prepend-icon="mdi-information"
        >
          <template v-slot:activator>
            <v-list-item class="noSpace">
              <v-list-item-title>Info</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item @click.native.passive="goImpressum">
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Impressum</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item @click.native.passive="goCookies">
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cookie-Details</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item @click.native.passive="goDatenschutz">
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Datenschutz</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item @click.native.passive="goAGBs">
            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>AGBs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--                    <v-list-item @click.native.passive="goQsginal">-->
          <!--                        <v-list-item-icon>-->
          <!--                            <v-icon>mdi-chevron-right</v-icon>-->
          <!--                        </v-list-item-icon>-->
          <!--                        <v-list-item-content>-->
          <!--                            <v-list-item-title>Qsignal IT Services</v-list-item-title>-->
          <!--                        </v-list-item-content>-->
          <!--                    </v-list-item>-->

        </v-list-group>
        <v-divider></v-divider>


        <v-list-item @click.native.passive="reload">
          <v-list-item-icon>
            <v-icon>mdi-refresh</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Neu laden</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <!--            <v-btn block color="accent" @click.native.passive="close">Close</v-btn>-->
      </div>

      <div class="text-center pt-6 pb-3 pointer" @click.passive="$ebus.$emit('gotoWebsite','https://qsignal.de')">
        <img style="width: 150px;" src="../assets/powered_by_qsignal.svg">
      </div>
      <div class="version pb-3">{{ displayAppVersion }}</div>

    </v-navigation-drawer>
  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants'
import * as firebaseUtil from '../firebase/firebaseUtil'
import * as bootstrap from '../vendor/bootstrap';
import * as util from "@/vendor/util";
import {enableGoodpay} from "../vendor/qconstants";
// import {swiper2} from "../vendor/swiper2";

export default {
  props: ['drawer'],
  data() {
    return {
      enableGoodpay: enableGoodpay,
      isApple: util.isIos(),
      thisDrawer: false,
      restorePhone: false,
      accountName: 'Account',
      displayAppVersion: 'v' + window.appVersion,
    }
  },
  computed: {
    takeawayEnabled() {
      return store.getters.enableTakeawayOhnePay || store.getters.enableTakeawayPay;
    },
    has2UseCases() {
      if (store.getters.enableInhousePay || qconst.enableInhouseOhnePay) {
        return this.takeawayEnabled;
      }
      return false;
    },
    withHome() {
      return store.state.withHome;
    },
    showInhouseMode() {
      return (store.getters.enableInhousePay || store.getters.enableInhouseOhnePay)
        && store.getters.deviceClass !== 'md';
    },
  },
  watch: {
    drawer(newValue) {
      this.thisDrawer = newValue;
      if (newValue) {
        // let gestureZone = document.getElementById('swiper');
        // swiper2.init(gestureZone, (e) => {
        //     // console.log('??? swipe event: ' + JSON.stringify(e));
        //     //{"direction":"left","movedPixels":84.88211059570312}
        //     if(e.direction === 'left'){
        //         this.close();
        //     }
        // })
      }
    },
    thisDrawer(newValue) {
      if (!newValue) {
        // this.ready = false;
        this.$emit('closeDrawer');
        // swiper2.destroy();
      }
    },
  },

  created() {
    ebus.$on('cb-wantQrOrder', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        this.doEnableInhouseMode();
      }
    });

    ebus.$on('cb-leaveInhouseMode', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        this.doEnableTakeawayMode();
      }
    });

    ebus.$on('accountUpdated', () => {
      //firebase user has been loaded or updated
      try {
        this.accountName = 'Account';
        // let user = firebaseUtil.getUser();
        // if (user && user.displayName && user.displayName.length > 3) {
        //     this.accountName = user.displayName;
        // }
      } catch (e) {

      }
    });
  },

  mounted() {

  },

  activated() {
  },

  destroyed() {
    // swiper2.destroy();
    util.clearEvents([
      'cb-leaveInhouseMode',
      'cb-wantQrOrder',
      'accountUpdated',
    ]);
  },

  methods: {
    enableInhouseMode() {
      ebus.$emit('showQuestion', {
        quest: ' Möchtest du an einem Tisch bestellen?',
        cb: 'cb-wantQrOrder'
      });
      this.close();
    },

    doEnableInhouseMode() {
      this.$store.commit('selectedDialog', 'TableQrCodeScanner');
      this.$store.commit('showDialogContainer', true);
      this.close();
    },

    enableTakeawayMode() {
      ebus.$emit('showQuestion', {
        quest: 'Möchtest du den Inhouse-Modus wirklich verlassen?',
        cb: 'cb-leaveInhouseMode'
      });
      this.close();
    },

    doEnableTakeawayMode() {
      ebus.$emit('clearInhouseModus', {eventSource:'Sidebar'});
      ebus.$emit('toast', 'Der Takeaway Modus ist jetzt aktiviert',);
    },

    hasAccount() {
      return bootstrap.hasAccount();
    },

    // gotoPhone() {
    //     var win = window.open('tel:+49 6237 9500484');
    // },

    register() {
      this.close();
      this.$router.push({name: 'Registrierung'});
    },

    // gotoWebsite(url) {
    //     let win = window.open(url, '_blank');
    //     win.focus();
    // },

    showTodo() {
      this.close();
      ebus.$emit('showInfo', {
        title: 'Diese Funktion ist in der Demo nicht verfügbar',
        text: 'Bei unseren Kunden steht diese Funktion natürlich zur Verfügung.',
      });
    },

    gotoHomeApp() {
      ebus.$emit('gotoHomeApp');
    },

    gotoAbholzeiten() {
      this.$router.push({name: 'Abholzeiten'});
    },

    reload() {
      // this.$ls.set('shouldReload', 'true');
      ebus.$emit('forceReload');
      // window.location = 'https://' + window.location.host + '/restaurant/' + slug + '/';
    },

    gotoStart() {
      this.close();
      // store.commit('currentTab', 'tab-1');
      // if (store.state.withHome) {
      //     ebus.$emit('gotoHomeApp');
      //     return;
      // }
      ebus.$emit('gotoStart');
      // this.$router.push({name: 'Home'});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    // gotoOeffnungszeiten() {
    //     this.$router.push({name: 'Oeffnungszeiten'});
    // },

    gotoOpeningHours() {
      this.close();
      this.$router.push({name: 'Filialen'});
    },

    gotoSortiment() {
      this.close();
      this.$router.push({name: 'Sortiment'});
    },

    goKellnerruf() {
      this.$router.push({name: 'Kellnerruf'});
    },

    gotoAktuelles() {
      this.$router.push({name: 'Aktuelles'});
    },

    gotoAnfahrt() {
      this.$router.push({name: 'Anfahrt'});
    },

    install() {
      ebus.$emit('installPrompt');
    },

    goLastOrders() {
      this.$router.push({name: 'Bestellungen'});
    },

    goProducts() {
      this.close();
      this.$router.push({name: 'Speisen', params: {catname: 'all'}});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    goCoupons() {
      this.close();
      this.$router.push({name: 'Coupons'});
    },

    goGutscheine() {
      this.close();
      this.$router.push({name: 'Gutscheine'});
    },

    // goOffers() {
    //     this.close();
    //     this.$router.push({name: 'order'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },

    goFavs() {
      this.close();
      this.$router.push({name: 'Favoriten'});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    // goSettings() {
    //     this.close();
    //     // store.commit('currentTab', 'tab-2');
    //     this.$router.push({name: 'Home'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },

    // goMarketing() {
    //     this.close();
    //     store.commit('currentTab', 'tab-1');
    //     this.$router.push({name: 'order'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },
    //
    // goCoaching() {
    //     this.close();
    //     store.commit('currentTab', 'tab-1');
    //     this.$router.push({name: 'order'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },
    //
    // goAnalyse() {
    //     this.close();
    //     store.commit('currentTab', 'tab-2');
    //     this.$router.push({name: 'order'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },

    goAGBs() {
      this.close();
      this.$router.push({name: 'AGB'});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    goAllergene() {
      this.close();
      this.$router.push({name: 'Allergene'});
    },

    // goQsginal(){
    //     let win = window.open('https://qsignal.de/', '_blank');
    //     win.focus();
    // },

    goDatenschutz() {
      this.close();
      this.$router.push({name: 'Datenschutz'});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    goImpressum() {
      this.close();
      this.$router.push({name: 'Impressum'});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    goCookies() {
      this.close();
      this.$router.push({name: 'Cookies'});
    },

    // goDisclaimer() {
    //     this.close();
    //     this.$router.push({name: 'disclaimer'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },

    // goPoweredBy() {
    //     this.close();
    //     this.$router.push({name: 'poweredBy'});
    //     ebus.$emit(qconst.notify$tabSwitched);
    // },

    goPaymentMethods() {
      this.close();
      this.$router.push({name: 'Zahlungsmittel'});
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    triggerKontakt() {
      ebus.$emit('triggerKontakt');
    },

    goAccountOrSignin() {
      this.close();
      if (store.getters.loggedIn) {
        this.$router.push({name: 'Account'});
      } else {
        this.signin();
      }
      // ebus.$emit(qconst.notify$tabSwitched);
    },

    // logout() {
    //     store.commit('isLoggingOut', true);
    //     firebaseUtil.logout((ok) => {
    //         // if (ok) {
    //         //     this.$notify({
    //         //         type: 'info',
    //         //         title: 'Logout erfolgreich!',
    //         //         text: ''
    //         //     });
    //         // }
    //     });
    // },

    signin() {
      this.close();
      this.$router.push({name: 'Anmelden'});
    },

    close() {
      this.thisDrawer = false;
      // this.$emit('closeDrawer');
    }
  }
}
</script>

<style lang="scss">
@import '../styles/base';

.version {
  pointer-events: none;
  /*position: fixed;*/
  /*z-index: 101;*/
  /*right: 2px;*/
  /*bottom: 2px;*/
  color: rgba(blue, 0.8);
  font-size: 16px;
  text-align: center;
}

.sideItem {
  background-color: $color-primary;
}

/*.myToolbar .listitem{*/
/*    cursor: pointer;*/
/*}*/

.myToolbar {
  background-color: $color-primary;
  color: white;
  overflow-x: hidden;

  td.maincell {
    padding: 2%;
  }


}


aside.vvd.v-navigation-drawer {
  max-height: var(--layout-height);

  //above toolbar
  z-index: 205;

  //Use this for navigation below toolbar and over tabs
  //z-index: 199;
  //top: 56px;
  //box-shadow: 0 7px 5px -5px rgba(0, 0, 0, 0.5) inset;
}

.sideContainer {

  .v-list-item {
    cursor: pointer;

    &:hover {
      background-color: rgba(0, 0, 0, 0.12) !important;
    }
  }


  .v-list-item__title {
    font-size: 1.2rem;
  }

  //  background-color: $primary-color-3-b;

  img {
    height: 24px;
    width: auto;
  }
}

/*.vvdAvatar.v-avatar {*/
/*    >>> .v-icon {*/
/*        font-size: 35px;*/
/*        //margin-left: -9px;*/
/*    }*/
/*}*/

</style>
